import { useParams } from 'react-router-dom';

import { AppUpdatePollPage } from '~/components/pages/AppUpdatePollPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppUpdatePollRoute: React.FC = () => {
  const { appId, pollId } = useParams();
  const navigate = useNavigate();

  if (!appId) {
    navigate('/');

    return null;
  }

  if (!pollId) {
    navigate(`/apps/${appId}/polls`);

    return null;
  }

  return (
    <DashboardTemplate appId={appId} noAppPreviewOverlap>
      <AppUpdatePollPage appId={appId} pollId={pollId} />
    </DashboardTemplate>
  );
};
